import { type ReadonlyURLSearchParams, useSearchParams } from 'next/navigation';
import { type PropsWithChildren, Suspense } from 'react';

import { SafeSearchParamsContext } from '@/features/safeSearchParams/context/SafeSearchParamsContext';

export function SafeSearchParamsProvider({ children }: PropsWithChildren): React.ReactNode {
  return (
    <Suspense
      fallback={
        <SafeSearchParamsContext.Provider value={new URLSearchParams() as ReadonlyURLSearchParams}>
          {children}
        </SafeSearchParamsContext.Provider>
      }
    >
      <WrappedSafeSearchParamsProvider>{children}</WrappedSafeSearchParamsProvider>
    </Suspense>
  );
}

function WrappedSafeSearchParamsProvider({ children }: PropsWithChildren): React.ReactNode {
  const searchParams = useSearchParams();

  return <SafeSearchParamsContext.Provider value={searchParams}>{children}</SafeSearchParamsContext.Provider>;
}
